import { IApiMarkup, ApiMarkupType, IApiMarkupUpdate, IApiMarkupDetails } from '@cbridge-packages/api';
import { StreamTranslator } from '@cbridge-packages/stream';
import { IMarkup, IMarkupDetails, MarkupType } from './markup.interface';

export namespace MarkupTranslator {
  export function fromApiSymbolDetails(markup: IApiMarkupDetails): IMarkupDetails {
    if (!markup) {
      return undefined;
    }

    return {
      symbolId: markup.id,
      coreSymbolName: markup.name,
      askMarkup: markup.askMarkup,
      bidMarkup: markup.bidMarkup,
      type: fromApiMarkupType(markup.type),
      streams: markup.streams?.map((stream) => ({
        ...StreamTranslator.fromApiBase(stream),
        nodeId: stream.nodeId,
      })),
      spreadProfile: markup.spreadProfile,
    };
  }

  export function fromApiSymbol(markup: IApiMarkup): IMarkup {
    if (!markup) {
      return undefined;
    }

    return {
      symbolId: markup.id,
      coreSymbolName: markup.name,
      askMarkup: markup.askMarkup,
      bidMarkup: markup.bidMarkup,
      type: fromApiMarkupType(markup.type),
      spreadProfileName: markup.spreadProfileName,
      tobMinSpread: markup.tobMinSpread,
      tobMaxSpread: markup.tobMaxSpread,
    };
  }

  export function toApi(markup: IMarkupDetails): IApiMarkupUpdate {
    return {
      askMarkup: markup.askMarkup,
      bidMarkup: markup.bidMarkup,
      type: toApiMarkupType(markup.type),
      spreadProfileId: markup.spreadProfile?.id ?? null,
    };
  }

  export function fromApiMarkupType(markupType: ApiMarkupType): MarkupType {
    if (markupType === ApiMarkupType.Points) {
      return MarkupType.Points;
    }

    return undefined;
  }

  export function toApiMarkupType(markupType: MarkupType): ApiMarkupType {
    if (markupType === MarkupType.Points) {
      return ApiMarkupType.Points;
    }

    return undefined;
  }
}
